import { Button } from '@chakra-ui/react'
import React from 'react'

import HeadsetMic from '@/components/assets/HeadsetMic'

const ConnectButton: React.FC<{ text: string; testId: string; onClick: () => void }> = ({ text, testId, onClick }) => {
    return (
        <Button colorScheme="gsk" data-testid={testId} onClick={onClick}>
            <HeadsetMic />
            {text}
        </Button>
    )
}

export default ConnectButton
